<template>
  <div class="page-header-title">
    <h3 class="m-b-10">{{ $t('lookupTitle') }}</h3>
  </div>
  <lookup-form-wrapper
    v-if="license"
    :license="license"
  ></lookup-form-wrapper>
  <p>{{isLoading}}</p>
  <div class="position-relative" v-if="!license">
    <spinner-component item-class="spinner-layout-gray"></spinner-component>
  </div>
</template>

<script>
import { computed, defineAsyncComponent } from 'vue'
import { store } from '@/application/store'

export default {
  name: 'LookupPage',
  components: {
    'lookup-form-wrapper': defineAsyncComponent(() => import('@/application/components/elements/LookupFormWrapper.vue')),
    'spinner-component': defineAsyncComponent(() => import('@/application/components/layout/SpinnerComponent.vue')),
  },
  setup() {
    const license = computed(() => store.getters.getLicense)
    return {
      license,
    }
  },
}
</script>
